import { useScrollTo } from '@/hooks/useScrollTo';

export default function Footer() {
  const scrollTo = useScrollTo();
  const year = new Date().getFullYear();

  const footerLinks = [
    { label: '首页', anchor: 'hero' },
    { label: '精选热播', anchor: 'media' },
    { label: '影视分类', anchor: 'index' },
    { label: '热播榜单', anchor: 'ranking' },
    { label: '常见问题', anchor: 'faq' },
    { label: '关于我们', anchor: 'about' },
  ];

  return (
    <footer id="footer" className="bg-background-800 text-background-50/90" style={{ backgroundColor: 'oklch(0.28 0.04 30)' }}>
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-play-circle-fill text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-xl text-background-50">嫩草视频</span>
            </div>
            <p className="text-background-50/60 text-sm leading-relaxed">
              嫩草视频聚合妖精视频、桃花视频、苹果视频、榴莲视频等平台热播影视剧，最新电视剧完整版高清在线观看，电影大全每日更新，追剧不等待。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-background-50 text-base mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              {footerLinks.slice(0, 4).map((link) => (
                <a
                  key={link.anchor}
                  href={`#${link.anchor}`}
                  onClick={(e) => { e.preventDefault(); scrollTo(link.anchor); }}
                  className="text-background-50/60 hover:text-accent-400 text-sm whitespace-nowrap cursor-pointer transition-colors"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-background-50 text-base mb-4">更多链接</h4>
            <div className="flex flex-col gap-2">
              {footerLinks.slice(4).map((link) => (
                <a
                  key={link.anchor}
                  href={`#${link.anchor}`}
                  onClick={(e) => { e.preventDefault(); scrollTo(link.anchor); }}
                  className="text-background-50/60 hover:text-accent-400 text-sm whitespace-nowrap cursor-pointer transition-colors"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-background-50 text-base mb-4">合作伙伴</h4>
            <p className="text-background-50/40 text-sm leading-relaxed">
              更多合作伙伴即将入驻，敬请期待。
            </p>
          </div>
        </div>

        <div className="border-t border-background-50/10 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-background-50/40 text-xs">
            &copy; {year} 嫩草视频 版权所有
          </p>
          <p className="text-background-50/40 text-xs">
            本站内容仅供学习交流，请支持正版影视作品
          </p>
        </div>
      </div>
    </footer>
  );
}